const PRODUCT_TOUR_KEY = "product-tour";

// Stores true/false value of whether product tour for a feature has been completed

const state = {
	productTour: localStorage.getItem(PRODUCT_TOUR_KEY)
		? JSON.parse(localStorage.getItem(PRODUCT_TOUR_KEY))
		: {
			dropMenu: false
		},
};

const persistNavGroup = (navGroup, key) => {
	localStorage.setItem(key, JSON.stringify(navGroup));
};

const getters = {
	productTour: (state) => {
		return state.productTour ? state.productTour : {
			dropMenu: false
		};
	}
};

const actions = {
	updateProductTourDropMenuCompleted({ commit, state }, completed) {
		let productTourState = state.productTour;
		productTourState.dropMenu = completed;
		commit("setProductTour", productTourState );
	},
};

const mutations = {
	setProductTour(state, productTour) {
		state.productTour = productTour;
		persistNavGroup(state.productTour, PRODUCT_TOUR_KEY)
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
